module.exports = "pegasus/assets/blocks/social-2-theme3.png";